export default function (self) {
  return {
    /**
     * Shorthand method for selecting a jQuery element intuitively based on
     * the calling instance and its declared className.
     *
     * Element names are appended to the calling instance's className
     * attribute with "__", e.g.
     *
     *   this.className = "view-class-name"
     *   ...
     *   this.$_element("input") => $("view-class-name__input")
     *
     * Modifiers are optional and are appended with "--", e.g.
     *
     *   this.className = "view-class-name"
     *   ...
     *   this.$_element("input", "title") => $("view-class-name__input--title")
     *
     * @param  {String} element Element name being selected, e.g. input, button
     * @param  {String} [modifier] Optional modifier string.
     * @return {jQuery} Selector result.
     */
    $_element: function (element, modifier = '') {
      let selector = `${self.className}__${element}`

      if (modifier) {
        selector += `--${modifier}`
      }

      const $el = self.$(`.${selector}`)
      $el.className = selector

      return $el
    },

    /**
     * Toggles a BEM modifier to a specified block__element.
     * @param {jQuery} [$container=null] Optional parent element containing the
     *    element to modify. If none is provided, use the root element.
     * @param {string} element Name of element to modify, e.g. input, button.
     * @param {string} modifier Name of modifier.
     * @param {boolean} enabled True to add modifier. False to remove.
     * @return {jQuery} Modified element.
     */
    $_toggleModifier: function ($container, element, modifier, enabled) {
      const clazz = `${element}--${modifier}`

      // If container is null, then we are operating on the root element
      if ($container) {
        return $container.find(`.${element}`).toggleClass(clazz, enabled)
      }

      return self.$el.toggleClass(clazz, enabled)
    },

    /**
     * Determines if a BEM modifier exists on a specified block__element.
     * @param {jQuery} [$container=null] Optional parent element containing the
     *    element to modify. If none is provided, use the root element.
     * @param {string} element Name of element to modify, e.g. input, button.
     * @param {string} modifier Name of modifier to check existence for.
     * @return {jQuery} True if element has modifier. False otherwise.
     */
    $_hasModifier: function ($container, element, modifier) {
      const clazz = `${element}--${modifier}`

      // If container is null, then we are operating on the root element
      if ($container) {
        return $container.find(`.${element}`).hasClass(clazz)
      }

      return self.$el.hasClass(clazz)
    }
  }
}
